import { cardList2, saleTitle, lineChart, shopRank, pieChart, hotChart, moreChart } from './components';
import { getLineChartData, getRankShopData, getPieTypeData, getHotSearchData, getMoreData } from '@/api/dashboard';
import { seriesMap } from './../echarts/map/components';
import { gradientsBar } from './../echarts/bar/components';
export default {
  name: 'index',
  components: {
    cardList: cardList2,
    lineChart,
    saleTitle,
    shopRank,
    pieChart,
    hotChart,
    moreChart,
    seriesMap,
    gradientsBar
  },
  data() {
    return {
      currentName: this.$t('销售额'),
      currentKey: 'sale',
      currentType: 'day',
      lineData: {},
      rankData: [],
      pieData: [],
      hotData: [],
      moreData: []
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getTitle(title, key) {
      if (title == this.currentName) {
        return;
      }
      this.currentName = title;
      this.currentKey = key;
      this.getLineData();
      this.getRankData();
    },
    getCurrent(type) {
      this.currentType = type;
      this.getData();
    },
    getData() {
      this.getLineData();
      this.getRankData();
      this.getPieData();
      this.getHotData();
      this.getMoreData();
    },
    async getLineData() {
      const {
        currentType: type,
        currentKey
      } = this;
      const {
        data
      } = await getLineChartData({
        type,
        currentKey
      });
      this.lineData = data || [];
    },
    async getRankData() {
      const {
        currentType: type,
        currentKey
      } = this;
      const {
        data
      } = await getRankShopData({
        type,
        currentKey
      });
      this.rankData = data || [];
    },
    async getPieData() {
      const {
        currentType: type
      } = this;
      const {
        data
      } = await getPieTypeData({
        type
      });
      this.pieData = data || [];
    },
    async getHotData() {
      const {
        currentType: type
      } = this;
      const {
        data
      } = await getHotSearchData({
        type
      });
      this.hotData = data || [];
    },
    async getMoreData() {
      const {
        currentType: type
      } = this;
      const {
        data
      } = await getMoreData({
        type
      });
      this.moreData = data || [];
    }
  }
};